import React from 'react';
import { motion } from 'framer-motion';
import { FaQuoteLeft } from 'react-icons/fa';

const LeaderProfile = ({ leader, index = 0 }) => {
  return (
    <motion.div 
      className="flex flex-col md:flex-row gap-8 items-center bg-white rounded-2xl overflow-hidden p-6 md:p-10 mb-12 border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
    >
      {/* Image Section - 40% */}
      <div className="w-full md:w-2/5 shrink-0">
        <div className="relative aspect-[3/4] md:aspect-square rounded-xl overflow-hidden shadow-lg">
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-10" />
          <motion.img 
            src={leader.image} 
            alt={leader.name}
            className="w-full h-full object-cover object-top"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5 }}
          />
        </div>
      </div>

      {/* Content Section - 60% */}
      <div className="w-full md:w-3/5 text-left space-y-6">
        <div>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            {leader.name}
          </h3>
          <p className="text-xl font-medium text-blue-600 uppercase tracking-wide">
            {leader.role}
          </p>
        </div>

        <div className="relative pl-8 border-l-4 border-blue-500/30">
          <FaQuoteLeft className="absolute -top-2 left-[-1.6rem] text-3xl text-blue-100 z-0" />
          <p className="relative z-10 text-lg md:text-xl text-gray-700 leading-relaxed italic">
            "{leader.vision}"
          </p>
        </div>
        
        {/* Additional non-quote text if needed, or just keep the vision highlight */}
        {leader.bio && (
             <p className="text-gray-600 leading-relaxed">
                {leader.bio}
             </p>
        )}
      </div>
    </motion.div>
  );
};

export default LeaderProfile;
